import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import {reactTableText} from '../../../constants/configs';
import ReactTable from 'react-table';
import Api from '../../../services/Api';
import {i18nizeDate, numberWithCommas} from '../../../helpers/Utils';
import {keyBy, mapValues, omit} from 'lodash';
import ReactTableTextFilter from '../../../components/ReactTableTextFilter';
import ReactTableSelectFilter from "../../../components/ReactTableSelectFilter";
import UserInfo from "../../../components/UserInfo";

class UsersList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      giftCards: [],
      pages: -1,
      loading: false
    };
    this.renderStatusFilter = this.renderStatusFilter.bind(this);
  }

  fetchData = async state => {
    try {
      this.setState({loading: true});
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/v2/admin-ui/giftCards',
        null,
        {
          params: {
            offset,
            limit: state.pageSize,
            ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'createdAt') : null),
            creatorType: 'USER',
          }
        }
      );
      this.setState({
        giftCards: data.rows,
        pages: Math.ceil(data.count / state.pageSize),
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  getColumns = t => [
    {
      Header: t('Name'),
      accessor: 'name',
      filterable: true,
      Filter: ReactTableTextFilter,
      minWidth: 200,
    },
    {
      Header: t('Gift Code'),
      accessor: 'code',
      filterable: true,
      Filter: ReactTableTextFilter,
      minWidth: 140,
    },
    {
      Header: t('Gifts'),
      accessor: 'gifts',
      Cell: props => {
        if (props.value.length > 1) {
          return (
            <ul dir="ltr" style={{marginBottom: 0}}>
              {props.value.map(item => (
                <li key={item.token} style={{textAlign: 'left'}}>{`${numberWithCommas(Number(item.amount))} ${item.token}`}</li>
              ))}
            </ul>
          );
        }
        return <div dir="ltr" className="text-left pr-4">{`${numberWithCommas(Number(props.value[0].amount))} ${props.value[0].token}`}</div>
      },
      width: 200,
    },
    {
      Header: t('Creator'),
      accessor: 'creator.value',
      Cell: props => {
        return (
          <UserInfo
            textColor="text-primary"
            label={t('User')}
            id={props.value}
            type="USER"
          />
        );
      }
    },
    {
      Header: t('Recipient'),
      accessor: 'recipient',
      Cell: props => {
        const {type, value} = props.value;
        return (
          <UserInfo
            onClick={() => {this.props.history.push('/dashboard/users/' + value);}}
            label={type === "UNKNOWN_USER" ? t('Not registered user') : t('User')}
            textColor="text-success"
            type={type}
            id={value}
          />
        );
      },
      minWidth: 140,
    },
    {
      Header: t('Status'),
      accessor: 'status',
      filterable: true,
      Filter: this.renderStatusFilter,
    },
    {
      Header: t('Registration Date'),
      accessor: 'createTime',
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      width: 150,
    },
    {
      Header: t('Expiration Date'),
      accessor: 'expireCriteria.time',
      Cell: props => <span>{props.value ? i18nizeDate(props.value) : "-------"}</span>,
      width: 150,
    },
  ];

  renderStatusFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {value: '', label: t('all')},
      {value: 'CREATED', label: t('CREATED')},
      {value: 'STARTED', label: t('STARTED')},
      {value: 'ACTIVATED', label: t('ACTIVATED')},
      {value: 'REFUNDED', label: t('REFUNDED')},
      {value: 'EXPIRED', label: t('EXPIRED')},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={options}
    />;
  }

  render() {
    const {t} = this.props;
    return (
      <ReactTable
        manual
        ref={el => {this.table = el;}}
        className="-highlight"
        data={this.state.giftCards}
        pages={this.state.pages}
        loading={this.state.loading}
        sortable={false}
        resizable={true}
        onFetchData={this.fetchData}
        columns={this.getColumns(t)}
        defaultPageSize={25}
        style={{
          width: '100%',
          marginTop: 20
        }}
        {...reactTableText}
      />
    );
  }
}

export default withTranslation()(UsersList);
